import axios from "axios";
import { refreshTokens } from "./AuthService";
import Cookies from "universal-cookie";
import { jwtDecode } from 'jwt-decode';

const client = axios.create({
    //baseURL: "http://localhost:8000/calendar"
    baseURL: "https://vp-backend-ysy4bqirgq-uc.a.run.app/calendar"
});

const cookies = new Cookies();
client.defaults.headers.common['Authorization'] = 'Bearer ' + cookies.get("jwt_authorization");


client.interceptors.response.use(resp => resp, async error => {   
    if (error.response.status === 401) {
        const data = {
            'refresh_token': cookies.get("refresh_token")
        }
        const response = await refreshTokens(JSON.stringify(data));

        if (response.id_token !== null) {
            client.defaults.headers.common['Authorization'] = 'Bearer ' + response.id_token;
            var userObject = jwtDecode(response.id_token);
            cookies.set("jwt_authorization", response.id_token, {
                expires: new Date(userObject.exp * 1000),
            });
            cookies.set("access_token", response.access_token, {
                expires: new Date(userObject.exp * 1000),
            });
            window.location.reload();
            return client(error.config);
        }
    }
});

export const createEvent = async (body) => {
    const promise = client.post('/create_event', body, {
        headers: {
            'Accept': '*/*',
            'Content-Type': 'application/json'
        }
    });
    const data = promise.then((response) => response);
    return data;
};

export const deleteEvent = async (body) => {
    const promise = client.post('/delete_event', body, {
        headers: {
            'Accept': '*/*',
            'Content-Type': 'application/json'
        }
    });
    const data = promise.then((response) => response);
    return data;
};